import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import ContractorDividedList from "./ContractorDividedList";


function ContractorDivided(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const curIndex = gVal("contractorDealing", false, -1);
    const tenderCompletedWithContract = (index) => getObjectValue("form.tenderCompletionData.divided." + index + ".tenderCompletionType", formikProps.values, null) === 'zawarcieUmowy';

    return (<FieldArray
        name={gId("divided")}
        render={() => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="contractorDealing"
                items={gVal("divided", true, [])}
                hideItem={(index) => !tenderCompletedWithContract(index)}
            />
            {curIndex > -1 &&
                <ContractorDividedList
                    formikProps={formikProps}
                    id={gId("divided." + curIndex)}
                    index={curIndex}
                />
            }

        </>)}
    />)
}

ContractorDivided.propTypes = {};

export default ContractorDivided;
